import React, {useEffect, useLayoutEffect, useState, useRef} from "react";
import {MenuNav} from '../../components/Menu';
import {Menu1} from "../User";
import {getListBanner} from "../../service/campaignService";
import Img from '../Images';
import { toast } from "react-toastify";
import { useLocation } from '@reach/router';
import {isAuth} from "../../helpers/general";
import {FromatNumberVIE} from '../../utils/format';
import {getListSuggest} from '../../service/searchService';

const Header1 =()=>{
    const location = useLocation();
    const [scrollPosition, setPosition] = useState(0);
    let yourAndroidDeepLink = 'https://play.google.com/store/apps/details?id=vn.com.bibomart.bibomart';
    let yourIOSDeepLink = 'https://apps.apple.com/vn/app/bibo-mart-siêu-thị-mẹ-và-bé/id1464298193?l=vi';
    useLayoutEffect(() => {
        function updatePosition() {
          setPosition(window.pageYOffset);
          window.localStorage.setItem("scrollPosition", window.pageYOffset);
        }
        window.addEventListener('scroll', updatePosition);
        updatePosition();

        return () => window.removeEventListener('scroll', updatePosition);
    }, []);
    const [operatingSystem, setOperatingSystem] = useState('Windows');
    const getOS = ()=> {
        var uA = navigator.userAgent || navigator.vendor || window.opera;
        if ((/iPad|iPhone|iPod/.test(uA) && !window.MSStream) || (uA.includes('Mac') && 'ontouchend' in document)) 
        { setOperatingSystem('iOS');}
      
        var i, os = ['Windows', 'Android', 'Unix', 'Mac', 'Linux', 'BlackBerry'];
        for (i = 0; i < os.length; i++) if (new RegExp(os[i],'i').test(uA)) {
            setOperatingSystem(os[i]);
        }     
    }
    const [bixu, setBixu] = useState(0);
    const [showMenu, setShowMenu] = useState(true);
    const [showCate, setShowCate] = useState(false);
    const path = ['/']
    useEffect(()=>{
        const _path = location.pathname;
       setShowMenu(path.includes(_path));
        if(_path === '/'){
                setShowCate(true);
        }
        getOS();
        loadBannerTop();
        setBixu(localStorage.getItem('bixu'));
    },[])
    const handleClickDownload =()=>{
        if(operatingSystem === 'iOS'){
            window.location.replace(yourIOSDeepLink);
        }else{
            window.location.replace(yourAndroidDeepLink);
        }
    }
    const [bannerItems, setBannerItems] = useState([]);
    const loadBannerTop=()=>{
        try {
            getListBanner('B001T01').then((response)=>{
                if(response.status === 200 && response['message'] !== 'Không tìm thấy dữ liệu.'){
                    setBannerItems(response['message']);
                }
            })
        } catch(err) {
          console.error(err);
        }  
    }
    const textSearchRef = useRef('');
      const handleSearch=()=>{
        let _keywword = textSearchRef.current.value;
        if(_keywword === ''){
            toast.warning('Bạn chưa nhập thông tin tìm kiếm.');
        }else{
            window.location.replace('/ket-qua-tim-kiem.html?'+encodeURI(_keywword));
        }
      }

      const handleSearchText =(text)=>{
        if(text === ''){
            toast.warning('Bạn chưa nhập thông tin tìm kiếm.');
        }else{
            window.location.replace('/ket-qua-tim-kiem.html?'+encodeURI(text));
        }
      }

      const [dataSuggest, setDataSuggest] = useState([]);
      const handleKeyPress = (e) => {
        try {
            getListSuggest(textSearchRef.current.value).then((response)=>{
                if(response.status === 200){
                    setDataSuggest(response.message);
                }
            })
        } catch (error) {
            console.log(error);
        }


        if (e.key === 'Enter') {
            let _keywword = textSearchRef.current.value;
            if(_keywword === ''){
                toast.warning('Bạn chưa nhập thông tin tìm kiếm.');
            }else{
                window.location.replace('/ket-qua-tim-kiem.html?'+encodeURI(_keywword));
            }
        }
      }
      const [itemsCart, setitemsCart] = useState([]);
      const [totalItem, setTotalItem]=useState(0);
      const call = setInterval(() => {
        setitemsCart([]);
        try{
            if(localStorage.getItem('key') !== null && localStorage.getItem('itemsCart') !== null && localStorage.getItem('itemsCart').includes('Yêu cầu không') === false){
                let _count = JSON.parse(localStorage.getItem('itemsCart'))??[];
                if(_count.length>0){
                    const _data_items = [];
                    _count?.forEach((item) => {
                        let _price = 0;
                        if(item.product?.price?.raw ){
                            if(item.product?.price?.raw !== undefined && item.product?.price?.raw > item.product?.price?.discount){
                                _price = item.product?.price?.discount;
                            }else{
                                _price = item.product?.price?.raw;
                            }
                        }
                        
                        let cart = {
                            id:item.product?._id,
                            sku:item.product?.sku,
                            linksp: item.product?.linksp,
                            quantity:item.quantity,
                            name:item.product?.name,
                            image:item.product?.thumbnail_mini,
                            price:_price,
                            price_old:item.product?.price?.raw,
                            saving_money:+item.product?.price?.raw - _price,
                            color:item.product?.variant?.color,
                            size:item.product?.variant?.size,
                            bixu:item.product?.bixu
                        }
                        _data_items.push(cart);
                    });
                    setTotalItem(_count.length);
                    setitemsCart(_data_items);
                }else{
                    setTotalItem(0);
                    setitemsCart([]);
                }
            }
            clearInterval(call);
        }catch(e){
            setTotalItem(0);
            setitemsCart([]);
            clearInterval(call);
            console.log(e);
        }
    }, 3000);

    let handleLogout = () => {
        localStorage.clear();
        window.location.replace('/');
    };
    return(
        <header className="header top-0 z-3">
            {
                bannerItems.length > 0 ?(
                <div className="header__top banner-top">
                    {
                       bannerItems[0].link !== '' ?(
                        <a href={bannerItems[0].link}>
                            <Img imgTitle={bannerItems[0].name} url={bannerItems[0].images} className="" style=""/></a>
                       ):(
                        <Img imgTitle={bannerItems[0].name} url={bannerItems[0].images} className="" style=""/>
                       ) 
                    }
                    
                </div>
                ):(null)
            }
            
            <div className="header__top position-relative">
                <div className="header__top--content m-auto">
                    <div className="row row--maint w-100 h-100 m-0">
                        <div className="col-6 p-0 my-auto">
                            <div className="d-flex flex-row">
                                <div className="my-auto"><a href="tel:+18006886"> <Img imgTitle='call' url='https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/hotline_call.png' className="icon--call pe-1" style=""/>Hotline <span className="text--danger">1800 68 86</span> (Miễn phí)</a></div>
                                <div className="thanh my-auto mx-2"></div>
                                <div className="my-auto"><a href="/he-thong-cua-hang.html"><Img imgTitle='call' url='/static/image/map.svg' className="icon--call pe-1" style=""/>Tìm siêu thị</a></div>
                            </div>
                        </div>
                        <div className="col-6 p-0 my-auto">
                            <div className="float-end d-flex flex-row">
                                <div className="my-auto pointer tooltip_QR" onClick={handleClickDownload}>Tải ứng dụng
                                    <div class="row position-absolute">
                                        <div class="col-12 p-0 position-relative">
                                            <img className="qa" src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/qr-tai-ap-20240617.png" alt="QA"/>
                                            <img className="download-qa" src="/static/image/download.svg" alt="download"/>
                                        </div>
                                    </div>
                                </div>
                                <div className="thanh my-auto mx-2"></div>

                        {
                            isAuth() === true ? (
                                <>
                                <div className="my-auto tooltip_user d-flex flex-row-reverse">
                                    <span className="pointer">{window.localStorage.getItem('name')}<i className="bi bi-chevron-down ps-1"></i></span>
                                    <div class="row position-absolute">
                                        <div className="dropdown-menu-bixu">
                                            <span className="bixu">{bixu !== 'undefined' ? FromatNumberVIE(bixu):0}</span> 
                                            <span className="bixu--text">Bixu</span>
                                        </div>
                                        <Menu1/>
                                        <ul className="menu-list-pointer pointer line">
                                            <li onClick={handleLogout}>
                                            <Img imgTitle='call' url='https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/logout.png' className="icon--call pe-1" style=""/>
                                                <span>Đăng xuất</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                </>        
                            ) : (
                                    <div className="my-auto"><a href="/dang-nhap.html">Đăng nhập</a></div>
                            )
                        }

                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {showMenu?(
                <div className={scrollPosition > 45 ?('fixed header header__middle bg-white'):('bg-white header__middle')}>
                    <div className="header__middle--content m-auto">
                        <div className="row row--maint m-0 w-100 h-auto">
                            <div className="col-2 p-0 my-auto">
                                <div className="w-100 h-100">
                                    <a href="/" aria-label><img className="w-100 h-100 " src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/logo.png" alt=""/></a>
                                </div> 
                            </div>
                            <div className="col-7 p-0 my-auto">
                                <div className="">
                                    <div className="row m-0 p-3 position-relative">
                                        <div className="col-11 p-0 ">
                                            <input className="input--serch w-100 py-2 px-3" type="text" placeholder="Ba mẹ cần tìm gì cho bé hôm nay?" ref={textSearchRef} onKeyUp={handleKeyPress}/>
                                        </div>
                                        <div className="button--serch col-1 p-0">
                                            <div className="text-white h-100 d-flex justify-content-center align-items-center " onClick={handleSearch}>
                                                <Img imgTitle='call' url='https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/Buttonseach.png' className="icon" style=""/>
                                            </div>
                                        </div>
                                        {
                                            dataSuggest.length > 0 ? (
                                                <div className="suggest">
                                                    <ul>
                                                        {
                                                           dataSuggest.map((item,i)=>{
                                                            return <li key={i} onClick={()=>handleSearchText(item)}>{item}</li>
                                                           }) 
                                                        }
                                                    </ul>
                                                </div>
                                            ):(null)
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="col-3 p-0 my-auto">
                                <div className="d-flex justify-content-end">
                                    <div className="my-auto text-center position-relative">
                                        <a href="/cart.html"><img className="icon mx-2" src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/cart_head.png" alt=""/>Giỏ hàng</a>
                                        <div className="number--cart position-absolute bg-danger text-white d-flex justify-content-center align-items-center">
                                        {
                                        totalItem > 9 ?(
                                            '9+'
                                        ):(totalItem) 
                                        }
                                        </div>
                                    </div>
                                    <div className="thanh ms-2 my-auto"></div>
                                    <div className="my-auto text-center"><a href="/account/noti.html"><img className="icon mx-2" src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/noti.png" alt=""/>Thông báo</a></div>
                                </div>
                            </div>
                        </div>
                        {
                        showCate ? (<MenuNav/>):(null)
                        }
                        
                    </div>
                </div>
                ):(
                    <div className={scrollPosition > 45 ?('fixed header bg-white header__middle'):('bg-white header__middle')}>
                    <div className="header__middle--content m-auto">
                        <div className="row row--maint m-0 w-100 h-auto">
                            <div className="col-2 p-0 my-auto">
                                <div className="w-100 h-100">
                                    <a href="/"><img className="w-100 h-100 " src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/logo.png" alt=""/></a>
                                </div> 
                            </div>
                            <div className="col-7 p-0 my-auto">
                                <div className="">
                                    <div className="row m-0 p-3 position-relative">
                                        <div className="col-11 p-0">
                                            <input className="input--serch w-100 py-2 px-3" type="text" placeholder="Ba mẹ cần tìm gì cho bé hôm nay?" ref={textSearchRef} onKeyUp={handleKeyPress}/>
                                        </div>
                                        <div className="button--serch col-1 p-0">
                                            <div className="text-white h-100 d-flex justify-content-center align-items-center " onClick={handleSearch}>
                                                <Img imgTitle='call' url='https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/Buttonseach.png' className="icon" style=""/>
                                            </div>
                                        </div>
                                        {
                                            dataSuggest.length > 0 ? (
                                                <div className="suggest">
                                                    <ul>
                                                        {
                                                           dataSuggest.map((item,i)=>{
                                                            return <li key={i} onClick={()=>handleSearchText(item)}>{item}</li>
                                                           }) 
                                                        }
                                                    </ul>
                                                </div>
                                            ):(null)
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="col-3 p-0 my-auto">
                                <div className="d-flex justify-content-end">
                                    <div className="my-auto text-center position-relative">
                                        <a href="/cart.html"><img className="icon mx-2" src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/cart_head.png" alt=""/>Giỏ hàng</a>
                                        <div className="number--cart position-absolute bg-danger text-white d-flex justify-content-center align-items-center">
                                        {
                                        totalItem > 9 ?(
                                           '9+'
                                        ):(totalItem) 
                                        }
                                        </div>
                                    </div>
                                    <div className="thanh ms-2 my-auto"></div>
                                    <div className="my-auto text-center"><a href="/account/noti.html"><img className="icon mx-2" src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/noti.png" alt=""/>Thông báo</a></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                )}
        </header>
    )
}
export default Header1;